/* MBG header — adds a "scrolled" class for the sticky header's condensed
   state. No dependencies, no layout reads on scroll beyond the cheap
   scrollY check, rAF-throttled. */
(function () {
  'use strict';

  var header = document.querySelector('.site-header');
  if (!header || header.classList.contains('site-header--static')) {
    return;
  }

  var THRESHOLD = 40;
  var ticking = false;

  function update() {
    header.classList.toggle('site-header--condensed', window.scrollY > THRESHOLD);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  update();
})();
